import type { FaireProductEntity } from "@faire/playground-entity-db/entity_types/product";
import { getEntityByToken } from "../get_entity";

const SEARCH_TOKENS = [
  "search_continuous_1",
  "search_continuous_2",
  "search_continuous_3",
  "search_continuous_4",
  "search_continuous_5",
  "search_continuous_6",
  "search_continuous_7",
  "search_continuous_8",
  "search_continuous_9",
  "search_continuous_10",
  "search_continuous_11",
  "search_continuous_12",
];

const TOAST_TOKENS = [
  "atc_toast_1",
  "atc_toast_2",
  "atc_toast_3",
  "atc_toast_4",
  "atc_toast_5",
  "atc_toast_6",
  "atc_toast_7",
  "atc_toast_8",
  "atc_toast_9",
  "atc_toast_10",
  "atc_toast_11",
  "atc_toast_12",
];

const read = (token: string): FaireProductEntity => {
  const entity = getEntityByToken(token, "product");
  if (!entity) {
    throw new Error(`Missing search/toast entity: ${token}`);
  }
  return entity;
};

export const searchContinuousProducts: FaireProductEntity[] =
  SEARCH_TOKENS.map(read);

export const atcToastProducts: FaireProductEntity[] = TOAST_TOKENS.map(read);
